import { APP_DISPLAY_DATE } from "@/utils/date-format";

/** ONLINE modes include payment ref; otherwise return the mode as plain text. */
export function onlineOrPlainPaymentText(
  mode: string | null | undefined,
  ref?: string | null
): string {
  return mode === "ONLINE" ? `${String(mode)} - (ref - ${String(ref ?? "")})` : String(mode ?? "");
}

/** Shared A5 chrome defaults used by receipt print-content mappers. */
export function defaultA5ChromeProps() {
  return {
    dateFormat: APP_DISPLAY_DATE,
    currency: "₹" as const,
    qrCodeSize: 100,
    digitalSignatureText: "Digitally Signed",
    footerNote:
      "VALID SUBJECT TO CLEARANCE. This receipt is computer generated and does not require a physical signature.",
    showReceiptBadge: true,
  };
}
